import { call, put } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import { submitApplicationFailure, submitApplicationSuccess } from '../../actions/ssap/ssapActionCreators';
import { configs } from '../../constants/configs/configs';

export function* submitSsapSaga({ ssapData }) {
    try {
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const response = yield call([ssapService, ssapService.saveApplication], ssapData);
        if(response.success) {
            yield put(
                push(
                    configs.routes.ELIGIBILITY_RESULTS,
                    {
                        prevLocation: configs.routes.SSAP,
                        encryptedCaseNumber: response.encryptedCaseNumber
                    }
                )
            );
            yield put(submitApplicationSuccess());
        } else {
            yield put(submitApplicationFailure());
        }
    } catch(e) {
        yield put(submitApplicationFailure());
    }
}